export type TComponent<T> = new (...args: any[]) => T;
